export const bicToName = (bic?: Bic | 'OTHER_BANK', shortNames = false) => {
  switch (bic) {
    case 'OTHER_BANK': // comdirect bank AG
      return 'bank';
    case 'COBADEHDXXX': // comdirect bank AG
      return 'comdirect';
    case 'DABBDEMMXXX': // DAB
      return shortNames ? 'DAB' : 'DAB BNP Paribas';
    case 'DEUTDEFFXXX': // DWS
      return 'DWS Vorsorge';
    case 'DEUTLU2DXXX': // DWS Investment -> MorgenFund
      return 'MorgenFund';
    case 'COBADEMXXXX': // ebase -> FNZ
      return 'FNZ';
    case 'FFBKDEFFTHK': // FIL Fondsbank (FFB)
      return shortNames ? 'FFB' : 'FFB (FIL Fondsbank)';
    case 'FODBDE77XXX': // Fondsdepot Bank
      return 'Fondsdepotbank';
    default:
      throw new Error('Given bic is invalid or has no name mapping defined');
  }
};

export const ORDERED_BICS: Bic[] = [
  'COBADEHDXXX',
  'COBADEMXXXX',
  'DABBDEMMXXX',
  'DEUTDEFFXXX',
  'DEUTLU2DXXX',
  'FFBKDEFFTHK',
  'FODBDE77XXX',
];
